<script>
/* eslint-disable vue/require-prop-types */
import { Line } from 'vue-chartjs'
export default {
  extends: Line,
  props: ['data','labels','options'],
  data() {
    return {
      xAxis:[],
    }
  },
  watch: {
    update: function() {
      this.createChart()
      // console.log('////// state updated ///////');
    },
    deep: true,
  },
  mounted () {
    this.createChart();
  },
  methods: {

    createChart() {

      // Overwriting base render method with actual data.
      this.renderChart({
        labels: this.labels,
        datasets: this.data
      })

    }
  },
  // computed: {
  //    ...mapGetters({
  //      update: 'getState'
  //    })
  //  }
}
</script>

<style>
</style>
